// eslint-disable-next-line
import firebase from "firebase/database";
import freon from "./hvac";
import Cryptr from "cryptr";

const cryptr = new Cryptr(atob(freon));

const encryptedText =
  "384ec5a0753d1759b9936e159bc6d5505e0a8bd9139b9278ddd75ca2c0ed58452e42cdcc8dba98f369152c2fedcce9a32d4c0e0d071c297c94a1c5b2fb4b6fbf86acb39c2a2dde96d7f31418419cdc3575a7bbc153fd9377075657d3d204b553aef71acc30135b533e7e262e42588ee62a543f0624836b0cfd55e186850748759a06da4500b6b3c0fe9aac94633654ad70bd7812986f928eb94b86f899e9761cb6b6fc6744be40b200b9b1d6d7cba0a2d6189c80865620b54199de028e138c5d79cbe75af7f02932e3ab08cfb5c965c7c37864a50d7629952251b239cc88d1a24753b06a244c899f0de7391ccd66f624d19991746034798d4cb4ecf5ecca34946723fa825e6a6ac948ffe77392e4baa69184c517df54ead3fcfa15650828ecaf00e77b4d8ab842f27015952e2fa9b2f18a1f2f94de5333053e355c90a652f3d2ffccfac2c8ea05836eb6edcec5dd421223438e881e448a5cef9d6ea85e100fc001c2f88c4615adc0251e1cbac82c4618a3d9f0e0bb56651e5a06a923d29e21e22164ef31500c1e93bbad0efd54a809cffb45cd941aad63261597e545bc3a8a7155eb15ac7de18c712325b6f9e709c7b7a67d0045";
const decrypted = cryptr.decrypt(encryptedText);
const firebaseConfig = JSON.parse(decrypted);

export default firebaseConfig;
